import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeroSection from './HeroSection';

const ServiceIntroductionInteractive = () => {
  const navigate = useNavigate();
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleGetStarted = () => {
    if (isHydrated) {
      navigate('/openplay/event');
    }
  };

  if (!isHydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-muted-foreground">로딩 중...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="relative">
      <HeroSection onGetStarted={handleGetStarted} />
    </div>
  );
};

export default ServiceIntroductionInteractive;
